export default __webpack_public_path__ + "static/media/no-result.903ca85d.svg";